<template>
  <div class="bg_mask mask_black">
    <vue-loading id="vue-loading" class="load" type="spin" color="#009FA9" :size="{ width: '120px', height: '120px' }"></vue-loading>
  </div>
</template>

<script>
import { VueLoading } from 'vue-loading-template'
export default {
  name: 'loading',
  // components: {
  //   VueLoading,
  // },
  mounted() {
    let svg = document.getElementById('vue-loading');
    let animateTransform = svg.getElementsByTagName('animateTransform')[0];
    animateTransform.setAttribute('dur', '1.5s'); // 回転速度を下げる
  }
}
</script>

<style lang="css" scoped>
.bg_mask{
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
}
.mask_black {
  background-color: rgba(0, 0, 0, .3);
}

.load.vue-loading {
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Loading.vue